// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"240":"support","374":"gameHistoryItem","472":"settings","488":"flashCards","555":"gameHistory","703":"addOrEditWord","982":"anki"}[chunkId] || chunkId) + "." + {"240":"7e5ea50a","374":"b4bad2e4","472":"a7611be3","488":"a39b50a2","555":"057188cc","703":"4380cbcf","849":"42a7e3ef","982":"240aa71f"}[chunkId] + ".js";
};